import { FC } from 'react';
import { ELoyaltyLevel } from '@xeppt/xeppt-sdk/types/loyalty';

interface IProps {
    goldPoints: number;
    platinumPoints: number;
    currentLevel?: ELoyaltyLevel;
}

const LoyaltyGraphicDesktop: FC<IProps> = ({ goldPoints, platinumPoints, currentLevel }) => {
    // Highlight (gold fill) the avatar for the user's CURRENT tier; grey out the others.
    // Previously the Gold avatar was hard-coded gold regardless of the user's actual tier.
    const GOLD_LIGHT = '#FFEDA4';
    const GOLD_DARK = '#EFBF04';
    const silverLight = currentLevel === ELoyaltyLevel.A ? GOLD_LIGHT : '#F0EFEF';
    const silverDark = currentLevel === ELoyaltyLevel.A ? GOLD_DARK : '#CCCCCC';
    const goldLight = currentLevel === ELoyaltyLevel.B ? GOLD_LIGHT : '#F0EFEF';
    const goldDark = currentLevel === ELoyaltyLevel.B ? GOLD_DARK : '#CCCCCC';
    const platinumLight = currentLevel === ELoyaltyLevel.C ? GOLD_LIGHT : '#F0F1F5';
    const platinumDark = currentLevel === ELoyaltyLevel.C ? GOLD_DARK : '#ADB3C0';
    return (
        <svg
            width="600"
            height="420"
            viewBox="0 0 600 420"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M296.199 299.334C235.996 356.685 160.305 395.324 65.3468 415.5H540V176.5H539.404C450.562 176.5 366.205 232.784 303.795 292.104C301.288 294.487 298.757 296.899 296.199 299.334Z"
                fill="#F5CC82"
                fillOpacity="0.2"
                stroke="#FFE9C0"
            />
            <path
                d="M180.206 339.367L180.163 339.408C150.121 368.239 112.888 403.969 65.025 415.5H300V296.5H299.952C255.512 296.5 212.647 308.243 181.552 338.075L180.206 339.367Z"
                fill="#F5CC82"
                fillOpacity="0.2"
                stroke="#FFE9C0"
            />
            <path
                d="M421.654 260.358L421.654 260.358C406.047 290.551 388.502 324.281 368.529 353.097C349.146 381.061 327.43 404.467 302.912 415.5H540V176.5H539.944C495.641 176.5 452.787 200.099 421.654 260.358Z"
                fill="#F5CC82"
                fillOpacity="0.2"
                stroke="#FFE9C0"
            />
            <line
                x1="540.5"
                y1="116.5"
                x2="540.5"
                y2="415.5"
                stroke="#DB9E2F"
                strokeLinecap="round"
                strokeDasharray="4 4"
            />
            <circle cx="540" cy="176" r="4" fill="#DB9E2F" />
            <path
                d="M559.799 108.799C570.734 97.8643 570.734 80.1357 559.799 69.201C548.864 58.2663 531.136 58.2663 520.201 69.201C509.266 80.1357 509.266 97.8643 520.201 108.799C531.136 119.734 548.864 119.734 559.799 108.799Z"
                fill={platinumLight}
            />
            <path
                d="M540.004 113.7C533.407 113.7 527.206 111.131 522.541 106.467C517.877 101.802 515.308 95.6005 515.308 89.0045C515.308 82.4085 517.877 76.2067 522.541 71.5422C527.206 66.8777 533.408 64.3086 540.004 64.3086C546.6 64.3086 552.801 66.8777 557.466 71.5422C562.13 76.2067 564.699 82.4085 564.699 89.0045C564.699 95.6005 562.13 101.802 557.466 106.467C552.801 111.131 546.6 113.7 540.004 113.7Z"
                fill={platinumDark}
            />
            <path
                d="M540.003 64.8184L540.351 65.5262L541.132 65.6395L540.568 66.19L540.701 66.9671L540.003 66.6001L539.305 66.9671L539.438 66.19L538.873 65.6395L539.654 65.5262L540.003 64.8184Z"
                fill={platinumLight}
            />
            <path
                d="M536.241 65.1113L536.697 65.7555L537.485 65.7452L537.013 66.3781L537.267 67.1243L536.52 66.8715L535.888 67.3434L535.898 66.5541L535.254 66.0991L536.007 65.865L536.241 65.1113Z"
                fill={platinumLight}
            />
            <path
                d="M532.574 65.9961L533.125 66.5607L533.903 66.4277L533.536 67.1262L533.903 67.8237L533.125 67.6907L532.574 68.2553L532.461 67.4754L531.754 67.1262L532.461 66.7769L532.574 65.9961Z"
                fill={platinumLight}
            />
            <path
                d="M529.087 67.4375L529.719 67.9084L530.466 67.6557L530.212 68.4028L530.684 69.0348L529.896 69.0245L529.44 69.6686L529.206 68.9159L528.452 68.6809L529.096 68.2258L529.087 67.4375Z"
                fill={platinumLight}
            />
            <path
                d="M525.869 69.4121L526.568 69.7791L527.265 69.4121L527.132 70.1892L527.697 70.7397L526.917 70.853L526.568 71.5608L526.218 70.853L525.438 70.7397L526.002 70.1892L525.869 69.4121Z"
                fill={platinumLight}
            />
            <path
                d="M522.999 71.8627L523.747 72.1164L524.379 71.6445L524.368 72.4329L525.012 72.8888L524.26 73.1229L524.026 73.8757L523.57 73.2315L522.781 73.2418L523.253 72.6098L522.999 71.8627Z"
                fill={platinumLight}
            />
            <path
                d="M520.55 74.7304L521.327 74.8634L521.877 74.2988L521.991 75.0797L522.699 75.4289L521.991 75.7781L521.877 76.558L521.327 75.9935L520.55 76.1264L520.917 75.4289L520.55 74.7304Z"
                fill={platinumLight}
            />
            <path
                d="M518.576 77.9483L519.365 77.9577L519.82 77.3145L520.055 78.0672L520.807 78.3013L520.163 78.7572L520.173 79.5456L519.541 79.0737L518.794 79.3274L519.047 78.5803L518.576 77.9483Z"
                fill={platinumLight}
            />
            <path
                d="M517.135 81.4374L517.916 81.3241L518.265 80.6172L518.614 81.3241L519.394 81.4374L518.829 81.9879L518.962 82.7659L518.265 82.3989L517.566 82.7659L517.699 81.9879L517.135 81.4374Z"
                fill={platinumLight}
            />
            <path
                d="M516.255 85.103L517.009 84.868L517.243 84.1152L517.698 84.7594L518.487 84.7491L518.015 85.3811L518.268 86.1282L517.522 85.8754L516.889 86.3464L516.899 85.558L516.255 85.103Z"
                fill={platinumLight}
            />
            <path
                d="M515.956 88.8644L516.663 88.5152L516.777 87.7344L517.328 88.2989L518.105 88.166L517.738 88.8644L518.105 89.562L517.328 89.429L516.777 89.9936L516.663 89.2137L515.956 88.8644Z"
                fill={platinumLight}
            />
            <path
                d="M516.255 92.6291L516.899 92.1731L516.889 91.3848L517.522 91.8566L518.268 91.6029L518.015 92.3501L518.487 92.982L517.698 92.9717L517.243 93.6159L517.009 92.8631L516.255 92.6291Z"
                fill={platinumLight}
            />
            <path
                d="M517.135 96.2954L517.699 95.7448L517.566 94.9668L518.265 95.3347L518.962 94.9668L518.829 95.7448L519.394 96.2954L518.614 96.4086L518.265 97.1165L517.916 96.4086L517.135 96.2954Z"
                fill={platinumLight}
            />
            <path
                d="M518.576 99.7838L519.047 99.1508L518.794 98.4046L519.541 98.6574L520.173 98.1855L520.163 98.9748L520.807 99.4298L520.055 99.6639L519.82 100.418L519.365 99.7735L518.576 99.7838Z"
                fill={platinumLight}
            />
            <path
                d="M520.55 103.003L520.917 102.306L520.55 101.607L521.327 101.74L521.877 101.176L521.991 101.957L522.699 102.306L521.991 102.654L521.877 103.435L521.327 102.87L520.55 103.003Z"
                fill={platinumLight}
            />
            <path
                d="M522.999 105.868L523.253 105.121L522.781 104.489L523.57 104.5L524.026 103.855L524.26 104.608L525.012 104.843L524.368 105.298L524.379 106.087L523.747 105.616L522.999 105.868Z"
                fill={platinumLight}
            />
            <path
                d="M525.869 108.321L526.002 107.543L525.438 106.992L526.218 106.879L526.568 106.172L526.917 106.879L527.697 106.992L527.132 107.543L527.265 108.321L526.568 107.954L525.869 108.321Z"
                fill={platinumLight}
            />
            <path
                d="M529.087 110.293L529.096 109.503L528.452 109.048L529.206 108.814L529.44 108.061L529.896 108.705L530.684 108.694L530.212 109.327L530.466 110.074L529.719 109.821L529.087 110.293Z"
                fill={platinumLight}
            />
            <path
                d="M532.574 111.738L532.461 110.957L531.754 110.609L532.461 110.259L532.574 109.479L533.125 110.043L533.903 109.91L533.536 110.609L533.903 111.306L533.125 111.173L532.574 111.738Z"
                fill={platinumLight}
            />
            <path
                d="M536.241 112.62L536.007 111.866L535.254 111.632L535.898 111.177L535.888 110.389L536.52 110.86L537.267 110.607L537.013 111.354L537.485 111.986L536.697 111.976L536.241 112.62Z"
                fill={platinumLight}
            />
            <path
                d="M540.003 112.914L539.654 112.207L538.873 112.094L539.438 111.544L539.305 110.766L540.003 111.133L540.701 110.766L540.568 111.544L541.132 112.094L540.351 112.207L540.003 112.914Z"
                fill={platinumLight}
            />
            <path
                d="M543.766 112.62L543.31 111.976L542.521 111.986L542.993 111.354L542.74 110.607L543.487 110.86L544.119 110.389L544.108 111.177L544.753 111.632L544 111.866L543.766 112.62Z"
                fill={platinumLight}
            />
            <path
                d="M547.433 111.738L546.883 111.173L546.104 111.306L546.472 110.609L546.104 109.91L546.883 110.043L547.433 109.479L547.546 110.259L548.254 110.609L547.546 110.957L547.433 111.738Z"
                fill={platinumLight}
            />
            <path
                d="M550.921 110.293L550.289 109.821L549.542 110.074L549.795 109.327L549.323 108.694L550.113 108.705L550.568 108.061L550.802 108.814L551.555 109.048L550.911 109.503L550.921 110.293Z"
                fill={platinumLight}
            />
            <path
                d="M554.142 108.321L553.445 107.954L552.746 108.321L552.879 107.543L552.314 106.992L553.095 106.879L553.445 106.172L553.793 106.879L554.574 106.992L554.009 107.543L554.142 108.321Z"
                fill={platinumLight}
            />
            <path
                d="M557.007 105.868L556.26 105.616L555.628 106.087L555.638 105.298L554.994 104.843L555.747 104.608L555.982 103.855L556.437 104.5L557.225 104.489L556.753 105.121L557.007 105.868Z"
                fill={platinumLight}
            />
            <path
                d="M559.463 103.003L558.685 102.87L558.135 103.435L558.021 102.654L557.314 102.306L558.021 101.957L558.135 101.176L558.685 101.74L559.463 101.607L559.096 102.306L559.463 103.003Z"
                fill={platinumLight}
            />
            <path
                d="M561.431 99.7838L560.642 99.7735L560.187 100.418L559.953 99.6639L559.199 99.4298L559.843 98.9748L559.833 98.1855L560.465 98.6574L561.212 98.4046L560.959 99.1508L561.431 99.7838Z"
                fill={platinumLight}
            />
            <path
                d="M562.876 96.2954L562.096 96.4086L561.746 97.1165L561.398 96.4086L560.617 96.2954L561.182 95.7448L561.049 94.9668L561.746 95.3347L562.445 94.9668L562.312 95.7448L562.876 96.2954Z"
                fill={platinumLight}
            />
            <path
                d="M563.758 92.6291L563.005 92.8631L562.771 93.6159L562.316 92.9717L561.526 92.982L561.998 92.3501L561.745 91.6029L562.493 91.8566L563.125 91.3848L563.114 92.1731L563.758 92.6291Z"
                fill={platinumLight}
            />
            <path
                d="M564.052 88.8644L563.345 89.2137L563.232 89.9936L562.68 89.429L561.903 89.562L562.27 88.8644L561.903 88.166L562.68 88.2989L563.232 87.7344L563.345 88.5152L564.052 88.8644Z"
                fill={platinumLight}
            />
            <path
                d="M563.758 85.103L563.114 85.558L563.125 86.3464L562.493 85.8754L561.745 86.1282L561.998 85.3811L561.526 84.7491L562.316 84.7594L562.771 84.1152L563.005 84.868L563.758 85.103Z"
                fill={platinumLight}
            />
            <path
                d="M562.876 81.4374L562.312 81.9879L562.445 82.7659L561.746 82.3989L561.049 82.7659L561.182 81.9879L560.617 81.4374L561.398 81.3241L561.746 80.6172L562.096 81.3241L562.876 81.4374Z"
                fill={platinumLight}
            />
            <path
                d="M561.431 77.9483L560.959 78.5803L561.212 79.3274L560.465 79.0737L559.833 79.5456L559.843 78.7572L559.199 78.3013L559.953 78.0672L560.187 77.3145L560.642 77.9577L561.431 77.9483Z"
                fill={platinumLight}
            />
            <path
                d="M559.463 74.7304L559.096 75.4289L559.463 76.1264L558.685 75.9935L558.135 76.558L558.021 75.7781L557.314 75.4289L558.021 75.0797L558.135 74.2988L558.685 74.8634L559.463 74.7304Z"
                fill={platinumLight}
            />
            <path
                d="M557.007 71.8627L556.753 72.6098L557.225 73.2418L556.437 73.2315L555.982 73.8757L555.747 73.1229L554.994 72.8888L555.638 72.4329L555.628 71.6445L556.26 72.1164L557.007 71.8627Z"
                fill={platinumLight}
            />
            <path
                d="M554.142 69.4121L554.009 70.1892L554.574 70.7397L553.793 70.853L553.445 71.5608L553.095 70.853L552.314 70.7397L552.879 70.1892L552.746 69.4121L553.445 69.7791L554.142 69.4121Z"
                fill={platinumLight}
            />
            <path
                d="M550.921 67.4375L550.911 68.2258L551.555 68.6809L550.802 68.9159L550.568 69.6686L550.113 69.0245L549.323 69.0348L549.795 68.4028L549.542 67.6557L550.289 67.9084L550.921 67.4375Z"
                fill={platinumLight}
            />
            <path
                d="M547.433 65.9961L547.546 66.7769L548.254 67.1262L547.546 67.4754L547.433 68.2553L546.883 67.6907L546.104 67.8237L546.472 67.1262L546.104 66.4277L546.883 66.5607L547.433 65.9961Z"
                fill={platinumLight}
            />
            <path
                d="M543.766 65.1113L544 65.865L544.753 66.0991L544.108 66.5541L544.119 67.3434L543.487 66.8715L542.74 67.1243L542.993 66.3781L542.521 65.7452L543.31 65.7555L543.766 65.1113Z"
                fill={platinumLight}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M545.481 84.1085C545.481 87.109 543.075 89.5149 540.072 89.5149C537.071 89.5149 534.664 87.109 534.664 84.1085C534.664 81.108 537.071 78.7031 540.072 78.7031C543.075 78.7031 545.481 81.108 545.481 84.1085ZM540.073 99.136C535.642 99.136 531.9 98.4157 531.9 95.6369C531.9 92.8571 535.665 92.1624 540.073 92.1624C544.506 92.1624 548.246 92.8826 548.246 95.6614C548.246 98.4412 544.481 99.136 540.073 99.136Z"
                fill={platinumLight}
            />
            <path
                d="M505.668 11.324C505.668 11.996 505.506 12.626 505.182 13.214C504.87 13.802 504.372 14.276 503.688 14.636C503.016 14.996 502.164 15.176 501.132 15.176H499.026V20H496.506V7.436H501.132C502.104 7.436 502.932 7.604 503.616 7.94C504.3 8.276 504.81 8.738 505.146 9.326C505.494 9.914 505.668 10.58 505.668 11.324ZM501.024 13.142C501.72 13.142 502.236 12.986 502.572 12.674C502.908 12.35 503.076 11.9 503.076 11.324C503.076 10.1 502.392 9.488 501.024 9.488H499.026V13.142H501.024ZM509.977 18.002H514.117V20H507.457V7.436H509.977V18.002ZM523.423 17.606H518.419L517.591 20H514.945L519.463 7.418H522.397L526.915 20H524.251L523.423 17.606ZM522.739 15.59L520.921 10.334L519.103 15.59H522.739ZM537.153 7.436V9.47H533.805V20H531.285V9.47H527.937V7.436H537.153ZM541.512 7.436V20H538.992V7.436H541.512ZM554.748 20H552.228L546.522 11.378V20H544.002V7.418H546.522L552.228 16.058V7.418H554.748V20ZM559.722 7.436V15.212C559.722 16.064 559.944 16.718 560.388 17.174C560.832 17.618 561.456 17.84 562.26 17.84C563.076 17.84 563.706 17.618 564.15 17.174C564.594 16.718 564.816 16.064 564.816 15.212V7.436H567.354V15.194C567.354 16.262 567.12 17.168 566.652 17.912C566.196 18.644 565.578 19.196 564.798 19.568C564.03 19.94 563.172 20.126 562.224 20.126C561.288 20.126 560.436 19.94 559.668 19.568C558.912 19.196 558.312 18.644 557.868 17.912C557.424 17.168 557.202 16.262 557.202 15.194V7.436H559.722ZM583.487 7.436V20H580.967V11.828L577.601 20H575.693L572.309 11.828V20H569.789V7.436H572.651L576.647 16.778L580.643 7.436H583.487Z"
                fill="black"
            />
            <text x="83.2%" y="10.2%" fill="#333">
                {platinumPoints}+ points
            </text>
            <line
                x1="300"
                y1="236.5"
                x2="300"
                y2="415.5"
                stroke="#DB9E2F"
                strokeLinecap="round"
                strokeDasharray="4 4"
            />
            <circle cx="300" cy="296" r="4" fill="#DB9E2F" />
            <path
                d="M319.799 228.799C330.734 217.864 330.734 200.136 319.799 189.201C308.864 178.266 291.136 178.266 280.201 189.201C269.266 200.136 269.266 217.864 280.201 228.799C291.136 239.734 308.864 239.734 319.799 228.799Z"
                fill={goldLight}
            />
            <path
                d="M299.998 233.695C293.401 233.695 287.2 231.125 282.535 226.461C277.871 221.796 275.302 215.595 275.302 208.999C275.302 202.403 277.871 196.201 282.535 191.536C287.2 186.872 293.402 184.303 299.998 184.303C306.594 184.303 312.796 186.872 317.46 191.536C322.124 196.201 324.694 202.403 324.694 208.999C324.694 215.595 322.124 221.796 317.46 226.461C312.796 231.125 306.594 233.695 299.998 233.695Z"
                fill={goldDark}
            />
            <path
                d="M300.003 184.818L300.352 185.526L301.133 185.639L300.568 186.19L300.702 186.967L300.003 186.6L299.305 186.967L299.439 186.19L298.873 185.639L299.654 185.526L300.003 184.818Z"
                fill={goldLight}
            />
            <path
                d="M296.242 185.111L296.697 185.755L297.486 185.745L297.014 186.378L297.268 187.124L296.521 186.872L295.888 187.343L295.898 186.554L295.254 186.099L296.008 185.865L296.242 185.111Z"
                fill={goldLight}
            />
            <path
                d="M292.575 185.996L293.126 186.561L293.903 186.428L293.536 187.126L293.903 187.824L293.126 187.691L292.575 188.255L292.462 187.475L291.754 187.126L292.462 186.777L292.575 185.996Z"
                fill={goldLight}
            />
            <path
                d="M289.086 187.438L289.718 187.908L290.465 187.656L290.212 188.403L290.683 189.035L289.895 189.024L289.44 189.669L289.205 188.916L288.452 188.681L289.096 188.226L289.086 187.438Z"
                fill={goldLight}
            />
            <path
                d="M285.868 189.412L286.567 189.779L287.265 189.412L287.131 190.189L287.697 190.74L286.916 190.853L286.567 191.561L286.217 190.853L285.438 190.74L286.002 190.189L285.868 189.412Z"
                fill={goldLight}
            />
            <path
                d="M283 191.863L283.747 192.116L284.379 191.645L284.369 192.433L285.013 192.889L284.26 193.123L284.026 193.876L283.571 193.232L282.781 193.242L283.253 192.61L283 191.863Z"
                fill={goldLight}
            />
            <path
                d="M280.55 194.73L281.327 194.863L281.877 194.299L281.992 195.08L282.699 195.429L281.992 195.778L281.877 196.558L281.327 195.993L280.55 196.126L280.917 195.429L280.55 194.73Z"
                fill={goldLight}
            />
            <path
                d="M278.576 197.948L279.365 197.958L279.82 197.314L280.055 198.067L280.808 198.301L280.164 198.757L280.173 199.546L279.541 199.074L278.794 199.327L279.048 198.58L278.576 197.948Z"
                fill={goldLight}
            />
            <path
                d="M277.135 201.437L277.915 201.324L278.264 200.617L278.613 201.324L279.394 201.437L278.829 201.988L278.962 202.766L278.264 202.399L277.566 202.766L277.699 201.988L277.135 201.437Z"
                fill={goldLight}
            />
            <path
                d="M276.255 205.103L277.008 204.868L277.242 204.115L277.698 204.759L278.486 204.749L278.014 205.381L278.268 206.128L277.521 205.875L276.889 206.346L276.899 205.558L276.255 205.103Z"
                fill={goldLight}
            />
            <path
                d="M275.956 208.864L276.664 208.515L276.777 207.734L277.328 208.299L278.106 208.166L277.739 208.864L278.106 209.562L277.328 209.429L276.777 209.994L276.664 209.214L275.956 208.864Z"
                fill={goldLight}
            />
            <path
                d="M276.255 212.629L276.899 212.173L276.889 211.385L277.521 211.857L278.268 211.603L278.014 212.35L278.486 212.982L277.698 212.972L277.242 213.616L277.008 212.863L276.255 212.629Z"
                fill={goldLight}
            />
            <path
                d="M277.135 216.295L277.699 215.745L277.566 214.967L278.264 215.335L278.962 214.967L278.829 215.745L279.394 216.295L278.613 216.409L278.264 217.116L277.915 216.409L277.135 216.295Z"
                fill={goldLight}
            />
            <path
                d="M278.576 219.784L279.048 219.151L278.794 218.405L279.541 218.657L280.173 218.186L280.164 218.975L280.808 219.43L280.055 219.664L279.82 220.418L279.365 219.773L278.576 219.784Z"
                fill={goldLight}
            />
            <path
                d="M280.55 223.003L280.917 222.306L280.55 221.607L281.327 221.74L281.877 221.176L281.992 221.957L282.699 222.306L281.992 222.654L281.877 223.435L281.327 222.87L280.55 223.003Z"
                fill={goldLight}
            />
            <path
                d="M283 225.868L283.253 225.121L282.781 224.489L283.571 224.5L284.026 223.855L284.26 224.608L285.013 224.843L284.369 225.298L284.379 226.087L283.747 225.616L283 225.868Z"
                fill={goldLight}
            />
            <path
                d="M285.868 228.321L286.002 227.543L285.438 226.992L286.217 226.879L286.567 226.172L286.916 226.879L287.697 226.992L287.131 227.543L287.265 228.321L286.567 227.954L285.868 228.321Z"
                fill={goldLight}
            />
            <path
                d="M289.086 230.293L289.096 229.503L288.452 229.048L289.205 228.814L289.44 228.061L289.895 228.705L290.683 228.694L290.212 229.327L290.465 230.074L289.718 229.821L289.086 230.293Z"
                fill={goldLight}
            />
            <path
                d="M292.575 231.738L292.462 230.957L291.754 230.609L292.462 230.259L292.575 229.479L293.126 230.043L293.903 229.91L293.536 230.609L293.903 231.306L293.126 231.173L292.575 231.738Z"
                fill={goldLight}
            />
            <path
                d="M296.242 232.62L296.008 231.866L295.254 231.632L295.898 231.177L295.888 230.389L296.521 230.86L297.268 230.607L297.014 231.354L297.486 231.986L296.697 231.976L296.242 232.62Z"
                fill={goldLight}
            />
            <path
                d="M300.003 232.914L299.654 232.207L298.873 232.094L299.439 231.544L299.305 230.766L300.003 231.133L300.702 230.766L300.568 231.544L301.133 232.094L300.352 232.207L300.003 232.914Z"
                fill={goldLight}
            />
            <path
                d="M303.766 232.62L303.311 231.976L302.521 231.986L302.993 231.354L302.741 230.607L303.488 230.86L304.12 230.389L304.109 231.177L304.754 231.632L304 231.866L303.766 232.62Z"
                fill={goldLight}
            />
            <path
                d="M307.438 231.738L306.887 231.173L306.11 231.306L306.477 230.609L306.11 229.91L306.887 230.043L307.438 229.479L307.552 230.259L308.259 230.609L307.552 230.957L307.438 231.738Z"
                fill={goldLight}
            />
            <path
                d="M310.921 230.293L310.289 229.821L309.541 230.074L309.795 229.327L309.323 228.694L310.112 228.705L310.568 228.061L310.802 228.814L311.554 229.048L310.91 229.503L310.921 230.293Z"
                fill={goldLight}
            />
            <path
                d="M314.143 228.321L313.445 227.954L312.746 228.321L312.88 227.543L312.314 226.992L313.095 226.879L313.445 226.172L313.794 226.879L314.575 226.992L314.009 227.543L314.143 228.321Z"
                fill={goldLight}
            />
            <path
                d="M317.008 225.868L316.261 225.616L315.628 226.087L315.638 225.298L314.994 224.843L315.748 224.608L315.982 223.855L316.437 224.5L317.226 224.489L316.754 225.121L317.008 225.868Z"
                fill={goldLight}
            />
            <path
                d="M319.463 223.003L318.686 222.87L318.136 223.435L318.022 222.654L317.314 222.306L318.022 221.957L318.136 221.176L318.686 221.74L319.463 221.607L319.096 222.306L319.463 223.003Z"
                fill={goldLight}
            />
            <path
                d="M321.43 219.784L320.642 219.773L320.186 220.418L319.952 219.664L319.199 219.43L319.843 218.975L319.833 218.186L320.465 218.657L321.212 218.405L320.958 219.151L321.43 219.784Z"
                fill={goldLight}
            />
            <path
                d="M322.877 216.295L322.096 216.409L321.747 217.116L321.398 216.409L320.617 216.295L321.183 215.745L321.049 214.967L321.747 215.335L322.446 214.967L322.312 215.745L322.877 216.295Z"
                fill={goldLight}
            />
            <path
                d="M323.757 212.629L323.005 212.863L322.771 213.616L322.315 212.972L321.526 212.982L321.998 212.35L321.745 211.603L322.492 211.857L323.124 211.385L323.114 212.173L323.757 212.629Z"
                fill={goldLight}
            />
            <path
                d="M324.052 208.864L323.344 209.214L323.231 209.994L322.68 209.429L321.903 209.562L322.27 208.864L321.903 208.166L322.68 208.299L323.231 207.734L323.344 208.515L324.052 208.864Z"
                fill={goldLight}
            />
            <path
                d="M323.757 205.103L323.114 205.558L323.124 206.346L322.492 205.875L321.745 206.128L321.998 205.381L321.526 204.749L322.315 204.759L322.771 204.115L323.005 204.868L323.757 205.103Z"
                fill={goldLight}
            />
            <path
                d="M322.877 201.437L322.312 201.988L322.446 202.766L321.747 202.399L321.049 202.766L321.183 201.988L320.617 201.437L321.398 201.324L321.747 200.617L322.096 201.324L322.877 201.437Z"
                fill={goldLight}
            />
            <path
                d="M321.43 197.948L320.958 198.58L321.212 199.327L320.465 199.074L319.833 199.546L319.843 198.757L319.199 198.301L319.952 198.067L320.186 197.314L320.642 197.958L321.43 197.948Z"
                fill={goldLight}
            />
            <path
                d="M319.463 194.73L319.096 195.429L319.463 196.126L318.686 195.993L318.136 196.558L318.022 195.778L317.314 195.429L318.022 195.08L318.136 194.299L318.686 194.863L319.463 194.73Z"
                fill={goldLight}
            />
            <path
                d="M317.008 191.863L316.754 192.61L317.226 193.242L316.437 193.232L315.982 193.876L315.748 193.123L314.994 192.889L315.638 192.433L315.628 191.645L316.261 192.116L317.008 191.863Z"
                fill={goldLight}
            />
            <path
                d="M314.143 189.412L314.009 190.189L314.575 190.74L313.794 190.853L313.445 191.561L313.095 190.853L312.314 190.74L312.88 190.189L312.746 189.412L313.445 189.779L314.143 189.412Z"
                fill={goldLight}
            />
            <path
                d="M310.921 187.438L310.91 188.226L311.554 188.681L310.802 188.916L310.568 189.669L310.112 189.024L309.323 189.035L309.795 188.403L309.541 187.656L310.289 187.908L310.921 187.438Z"
                fill={goldLight}
            />
            <path
                d="M307.438 185.996L307.552 186.777L308.259 187.126L307.552 187.475L307.438 188.255L306.887 187.691L306.11 187.824L306.477 187.126L306.11 186.428L306.887 186.561L307.438 185.996Z"
                fill={goldLight}
            />
            <path
                d="M303.766 185.111L304 185.865L304.754 186.099L304.109 186.554L304.12 187.343L303.488 186.872L302.741 187.124L302.993 186.378L302.521 185.745L303.311 185.755L303.766 185.111Z"
                fill={goldLight}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M305.328 204.109C305.328 207.109 302.923 209.515 299.92 209.515C296.918 209.515 294.512 207.109 294.512 204.109C294.512 201.108 296.918 198.703 299.92 198.703C302.923 198.703 305.328 201.108 305.328 204.109ZM299.921 219.136C295.49 219.136 291.748 218.416 291.748 215.637C291.748 212.857 295.513 212.162 299.921 212.162C304.353 212.162 308.094 212.883 308.094 215.661C308.094 218.441 304.329 219.136 299.921 219.136Z"
                fill={goldLight}
            />
            <path
                d="M285.933 131.216C285.645 130.688 285.249 130.286 284.745 130.01C284.241 129.734 283.653 129.596 282.981 129.596C282.237 129.596 281.577 129.764 281.001 130.1C280.425 130.436 279.975 130.916 279.651 131.54C279.327 132.164 279.165 132.884 279.165 133.7C279.165 134.54 279.327 135.272 279.651 135.896C279.987 136.52 280.449 137 281.037 137.336C281.625 137.672 282.309 137.84 283.089 137.84C284.049 137.84 284.835 137.588 285.447 137.084C286.059 136.568 286.461 135.854 286.653 134.942H282.333V133.016H289.137V135.212C288.969 136.088 288.609 136.898 288.057 137.642C287.505 138.386 286.791 138.986 285.915 139.442C285.051 139.886 284.079 140.108 282.999 140.108C281.787 140.108 280.689 139.838 279.705 139.298C278.733 138.746 277.965 137.984 277.401 137.012C276.849 136.04 276.573 134.936 276.573 133.7C276.573 132.464 276.849 131.36 277.401 130.388C277.965 129.404 278.733 128.642 279.705 128.102C280.689 127.55 281.781 127.274 282.981 127.274C284.397 127.274 285.627 127.622 286.671 128.318C287.715 129.002 288.435 129.968 288.831 131.216H285.933ZM296.834 140.126C295.658 140.126 294.578 139.85 293.594 139.298C292.61 138.746 291.83 137.984 291.254 137.012C290.678 136.028 290.39 134.918 290.39 133.682C290.39 132.458 290.678 131.36 291.254 130.388C291.83 129.404 292.61 128.636 293.594 128.084C294.578 127.532 295.658 127.256 296.834 127.256C298.022 127.256 299.102 127.532 300.074 128.084C301.058 128.636 301.832 129.404 302.396 130.388C302.972 131.36 303.26 132.458 303.26 133.682C303.26 134.918 302.972 136.028 302.396 137.012C301.832 137.984 301.058 138.746 300.074 139.298C299.09 139.85 298.01 140.126 296.834 140.126ZM296.834 137.876C297.59 137.876 298.256 137.708 298.832 137.372C299.408 137.024 299.858 136.532 300.182 135.896C300.506 135.26 300.668 134.522 300.668 133.682C300.668 132.842 300.506 132.11 300.182 131.486C299.858 130.85 299.408 130.364 298.832 130.028C298.256 129.692 297.59 129.524 296.834 129.524C296.078 129.524 295.406 129.692 294.818 130.028C294.242 130.364 293.792 130.85 293.468 131.486C293.144 132.11 292.982 132.842 292.982 133.682C292.982 134.522 293.144 135.26 293.468 135.896C293.792 136.532 294.242 137.024 294.818 137.372C295.406 137.708 296.078 137.876 296.834 137.876ZM307.655 138.002H311.795V140H305.135V127.436H307.655V138.002ZM317.788 127.436C319.108 127.436 320.266 127.694 321.262 128.21C322.27 128.726 323.044 129.464 323.584 130.424C324.136 131.372 324.412 132.476 324.412 133.736C324.412 134.996 324.136 136.1 323.584 137.048C323.044 137.984 322.27 138.71 321.262 139.226C320.266 139.742 319.108 140 317.788 140H313.396V127.436H317.788ZM317.698 137.858C319.018 137.858 320.038 137.498 320.758 136.778C321.478 136.058 321.838 135.044 321.838 133.736C321.838 132.428 321.478 131.408 320.758 130.676C320.038 129.932 319.018 129.56 317.698 129.56H315.916V137.858H317.698Z"
                fill="black"
            />
            <text x="42%" y="39%" fill="#333">
                {goldPoints} - {platinumPoints - 1} points
            </text>
            <line
                x1="61"
                y1="415.5"
                x2="61"
                y2="355.5"
                stroke="#DB9E2F"
                strokeLinecap="round"
                strokeDasharray="4 4"
            />
            <circle cx="61" cy="416" r="4" fill="#DB9E2F" />
            <path
                d="M80.799 347.799C91.7337 336.864 91.7337 319.136 80.799 308.201C69.8643 297.266 52.1357 297.266 41.201 308.201C30.2663 319.136 30.2663 336.864 41.201 347.799C52.1357 358.734 69.8643 358.734 80.799 347.799Z"
                fill={silverLight}
            />
            <path
                d="M61.0035 352.7C54.4066 352.7 48.2057 350.131 43.5412 345.467C38.8767 340.802 36.3076 334.601 36.3076 328.005C36.3076 321.409 38.8767 315.207 43.5412 310.542C48.2057 305.878 54.4075 303.309 61.0035 303.309C67.5995 303.309 73.8014 305.878 78.4658 310.542C83.1303 315.207 85.6994 321.409 85.6994 328.005C85.6994 334.601 83.1303 340.802 78.4658 345.467C73.8014 350.131 67.5995 352.7 61.0035 352.7Z"
                fill={silverDark}
            />
            <path
                d="M61.0031 303.818L61.3514 304.526L62.1323 304.639L61.5677 305.19L61.7006 305.967L61.0031 305.6L60.3047 305.967L60.4376 305.19L59.873 304.639L60.6539 304.526L61.0031 303.818Z"
                fill={silverLight}
            />
            <path
                d="M57.2407 304.111L57.6967 304.755L58.485 304.745L58.0132 305.378L58.2669 306.124L57.5197 305.872L56.8878 306.343L56.898 305.554L56.2539 305.099L57.0067 304.865L57.2407 304.111Z"
                fill={silverLight}
            />
            <path
                d="M53.5741 304.996L54.1246 305.561L54.9027 305.428L54.5356 306.126L54.9027 306.824L54.1246 306.691L53.5741 307.255L53.4608 306.475L52.7539 306.126L53.4608 305.777L53.5741 304.996Z"
                fill={silverLight}
            />
            <path
                d="M50.0869 306.438L50.7189 306.908L51.466 306.656L51.2123 307.403L51.6842 308.035L50.8959 308.024L50.4399 308.669L50.2058 307.916L49.4521 307.681L50.0963 307.226L50.0869 306.438Z"
                fill={silverLight}
            />
            <path
                d="M46.8691 308.412L47.5676 308.779L48.2651 308.412L48.1322 309.189L48.6967 309.74L47.9168 309.853L47.5676 310.561L47.2184 309.853L46.4375 309.74L47.0021 309.189L46.8691 308.412Z"
                fill={silverLight}
            />
            <path
                d="M43.9994 310.863L44.7465 311.116L45.3785 310.645L45.3682 311.433L46.0124 311.889L45.2596 312.123L45.0256 312.876L44.5696 312.232L43.7812 312.242L44.2531 311.61L43.9994 310.863Z"
                fill={silverLight}
            />
            <path
                d="M41.5498 313.73L42.3269 313.863L42.8774 313.299L42.9907 314.08L43.6985 314.429L42.9907 314.778L42.8774 315.558L42.3269 314.993L41.5498 315.126L41.9168 314.429L41.5498 313.73Z"
                fill={silverLight}
            />
            <path
                d="M39.5762 316.948L40.3645 316.958L40.8195 316.314L41.0545 317.067L41.8073 317.301L41.1631 317.757L41.1734 318.546L40.5415 318.074L39.7943 318.327L40.0471 317.58L39.5762 316.948Z"
                fill={silverLight}
            />
            <path
                d="M38.1348 320.437L38.9156 320.324L39.2648 319.617L39.6141 320.324L40.394 320.437L39.8294 320.988L39.9624 321.766L39.2648 321.399L38.5664 321.766L38.6993 320.988L38.1348 320.437Z"
                fill={silverLight}
            />
            <path
                d="M37.2549 324.103L38.0086 323.868L38.2426 323.115L38.6977 323.759L39.487 323.749L39.0151 324.381L39.2679 325.128L38.5217 324.875L37.8887 325.346L37.899 324.558L37.2549 324.103Z"
                fill={silverLight}
            />
            <path
                d="M36.9561 327.864L37.6629 327.515L37.7772 326.734L38.3277 327.299L39.1048 327.166L38.7378 327.864L39.1048 328.562L38.3277 328.429L37.7772 328.994L37.6629 328.214L36.9561 327.864Z"
                fill={silverLight}
            />
            <path
                d="M37.2549 331.629L37.899 331.173L37.8887 330.385L38.5217 330.857L39.2679 330.603L39.0151 331.35L39.487 331.982L38.6977 331.972L38.2426 332.616L38.0086 331.863L37.2549 331.629Z"
                fill={silverLight}
            />
            <path
                d="M38.1348 335.295L38.6993 334.745L38.5664 333.967L39.2648 334.335L39.9624 333.967L39.8294 334.745L40.394 335.295L39.6141 335.409L39.2648 336.116L38.9156 335.409L38.1348 335.295Z"
                fill={silverLight}
            />
            <path
                d="M39.5762 338.784L40.0471 338.151L39.7943 337.405L40.5415 337.657L41.1734 337.186L41.1631 337.975L41.8073 338.43L41.0545 338.664L40.8195 339.418L40.3645 338.773L39.5762 338.784Z"
                fill={silverLight}
            />
            <path
                d="M41.5498 342.003L41.9168 341.306L41.5498 340.607L42.3269 340.74L42.8774 340.176L42.9907 340.957L43.6985 341.306L42.9907 341.654L42.8774 342.435L42.3269 341.87L41.5498 342.003Z"
                fill={silverLight}
            />
            <path
                d="M43.9994 344.868L44.2531 344.121L43.7812 343.489L44.5696 343.5L45.0256 342.855L45.2596 343.608L46.0124 343.843L45.3682 344.298L45.3785 345.087L44.7465 344.616L43.9994 344.868Z"
                fill={silverLight}
            />
            <path
                d="M46.8691 347.321L47.0021 346.543L46.4375 345.992L47.2184 345.879L47.5676 345.172L47.9168 345.879L48.6967 345.992L48.1322 346.543L48.2651 347.321L47.5676 346.954L46.8691 347.321Z"
                fill={silverLight}
            />
            <path
                d="M50.0869 349.293L50.0963 348.503L49.4521 348.048L50.2058 347.814L50.4399 347.061L50.8959 347.705L51.6842 347.694L51.2123 348.327L51.466 349.074L50.7189 348.821L50.0869 349.293Z"
                fill={silverLight}
            />
            <path
                d="M53.5741 350.738L53.4608 349.957L52.7539 349.609L53.4608 349.259L53.5741 348.479L54.1246 349.043L54.9027 348.91L54.5356 349.609L54.9027 350.306L54.1246 350.173L53.5741 350.738Z"
                fill={silverLight}
            />
            <path
                d="M57.2407 351.62L57.0067 350.866L56.2539 350.632L56.898 350.177L56.8878 349.389L57.5197 349.86L58.2669 349.607L58.0132 350.354L58.485 350.986L57.6967 350.976L57.2407 351.62Z"
                fill={silverLight}
            />
            <path
                d="M61.0031 351.914L60.6539 351.207L59.873 351.094L60.4376 350.544L60.3047 349.766L61.0031 350.133L61.7006 349.766L61.5677 350.544L62.1323 351.094L61.3514 351.207L61.0031 351.914Z"
                fill={silverLight}
            />
            <path
                d="M64.7658 351.62L64.3098 350.976L63.5215 350.986L63.9934 350.354L63.7396 349.607L64.4868 349.86L65.1188 349.389L65.1085 350.177L65.7526 350.632L64.9999 350.866L64.7658 351.62Z"
                fill={silverLight}
            />
            <path
                d="M68.4331 350.738L67.8825 350.173L67.1045 350.306L67.4715 349.609L67.1045 348.91L67.8825 349.043L68.4331 348.479L68.5464 349.259L69.2542 349.609L68.5464 349.957L68.4331 350.738Z"
                fill={silverLight}
            />
            <path
                d="M71.9214 349.293L71.2885 348.821L70.5423 349.074L70.7951 348.327L70.3232 347.694L71.1125 347.705L71.5675 347.061L71.8016 347.814L72.5553 348.048L71.9111 348.503L71.9214 349.293Z"
                fill={silverLight}
            />
            <path
                d="M75.142 347.321L74.4445 346.954L73.7461 347.321L73.879 346.543L73.3145 345.992L74.0953 345.879L74.4445 345.172L74.7928 345.879L75.5737 345.992L75.0091 346.543L75.142 347.321Z"
                fill={silverLight}
            />
            <path
                d="M78.0071 344.868L77.26 344.616L76.628 345.087L76.6383 344.298L75.9941 343.843L76.7469 343.608L76.9819 342.855L77.4369 343.5L78.2253 343.489L77.7534 344.121L78.0071 344.868Z"
                fill={silverLight}
            />
            <path
                d="M80.4632 342.003L79.6852 341.87L79.1346 342.435L79.0213 341.654L78.3145 341.306L79.0213 340.957L79.1346 340.176L79.6852 340.74L80.4632 340.607L80.0962 341.306L80.4632 342.003Z"
                fill={silverLight}
            />
            <path
                d="M82.4313 338.784L81.642 338.773L81.187 339.418L80.9529 338.664L80.1992 338.43L80.8434 337.975L80.8331 337.186L81.4651 337.657L82.2122 337.405L81.9594 338.151L82.4313 338.784Z"
                fill={silverLight}
            />
            <path
                d="M83.8764 335.295L83.0956 335.409L82.7463 336.116L82.398 335.409L81.6172 335.295L82.1818 334.745L82.0488 333.967L82.7463 334.335L83.4448 333.967L83.3118 334.745L83.8764 335.295Z"
                fill={silverLight}
            />
            <path
                d="M84.7584 331.629L84.0047 331.863L83.7707 332.616L83.3157 331.972L82.5264 331.982L82.9982 331.35L82.7455 330.603L83.4926 330.857L84.1246 330.385L84.1143 331.173L84.7584 331.629Z"
                fill={silverLight}
            />
            <path
                d="M85.052 327.864L84.3452 328.214L84.2319 328.994L83.6804 328.429L82.9033 328.562L83.2704 327.864L82.9033 327.166L83.6804 327.299L84.2319 326.734L84.3452 327.515L85.052 327.864Z"
                fill={silverLight}
            />
            <path
                d="M84.7584 324.103L84.1143 324.558L84.1246 325.346L83.4926 324.875L82.7455 325.128L82.9982 324.381L82.5264 323.749L83.3157 323.759L83.7707 323.115L84.0047 323.868L84.7584 324.103Z"
                fill={silverLight}
            />
            <path
                d="M83.8764 320.437L83.3118 320.988L83.4448 321.766L82.7463 321.399L82.0488 321.766L82.1818 320.988L81.6172 320.437L82.398 320.324L82.7463 319.617L83.0956 320.324L83.8764 320.437Z"
                fill={silverLight}
            />
            <path
                d="M82.4313 316.948L81.9594 317.58L82.2122 318.327L81.4651 318.074L80.8331 318.546L80.8434 317.757L80.1992 317.301L80.9529 317.067L81.187 316.314L81.642 316.958L82.4313 316.948Z"
                fill={silverLight}
            />
            <path
                d="M80.4632 313.73L80.0962 314.429L80.4632 315.126L79.6852 314.993L79.1346 315.558L79.0213 314.778L78.3145 314.429L79.0213 314.08L79.1346 313.299L79.6852 313.863L80.4632 313.73Z"
                fill={silverLight}
            />
            <path
                d="M78.0071 310.863L77.7534 311.61L78.2253 312.242L77.4369 312.232L76.9819 312.876L76.7469 312.123L75.9941 311.889L76.6383 311.433L76.628 310.645L77.26 311.116L78.0071 310.863Z"
                fill={silverLight}
            />
            <path
                d="M75.142 308.412L75.0091 309.189L75.5737 309.74L74.7928 309.853L74.4445 310.561L74.0953 309.853L73.3145 309.74L73.879 309.189L73.7461 308.412L74.4445 308.779L75.142 308.412Z"
                fill={silverLight}
            />
            <path
                d="M71.9214 306.438L71.9111 307.226L72.5553 307.681L71.8016 307.916L71.5675 308.669L71.1125 308.024L70.3232 308.035L70.7951 307.403L70.5423 306.656L71.2885 306.908L71.9214 306.438Z"
                fill={silverLight}
            />
            <path
                d="M68.4331 304.996L68.5464 305.777L69.2542 306.126L68.5464 306.475L68.4331 307.255L67.8825 306.691L67.1045 306.824L67.4715 306.126L67.1045 305.428L67.8825 305.561L68.4331 304.996Z"
                fill={silverLight}
            />
            <path
                d="M64.7658 304.111L64.9999 304.865L65.7526 305.099L65.1085 305.554L65.1188 306.343L64.4868 305.872L63.7396 306.124L63.9934 305.378L63.5215 304.745L64.3098 304.755L64.7658 304.111Z"
                fill={silverLight}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.4808 323.109C66.4808 326.109 64.075 328.515 61.0724 328.515C58.0708 328.515 55.664 326.109 55.664 323.109C55.664 320.108 58.0708 317.703 61.0724 317.703C64.075 317.703 66.4808 320.108 66.4808 323.109ZM61.0733 338.136C56.6419 338.136 52.9004 337.416 52.9004 334.637C52.9004 331.857 56.6654 331.162 61.0733 331.162C65.5056 331.162 69.2461 331.883 69.2461 334.661C69.2461 337.441 65.4811 338.136 61.0733 338.136Z"
                fill={silverLight}
            />
            <path
                d="M38.0058 260.126C37.1298 260.126 36.3378 259.976 35.6298 259.676C34.9338 259.376 34.3818 258.944 33.9738 258.38C33.5658 257.816 33.3558 257.15 33.3438 256.382H36.0438C36.0798 256.898 36.2598 257.306 36.5838 257.606C36.9198 257.906 37.3758 258.056 37.9518 258.056C38.5398 258.056 39.0018 257.918 39.3378 257.642C39.6738 257.354 39.8418 256.982 39.8418 256.526C39.8418 256.154 39.7278 255.848 39.4998 255.608C39.2718 255.368 38.9838 255.182 38.6358 255.05C38.2998 254.906 37.8318 254.75 37.2318 254.582C36.4158 254.342 35.7498 254.108 35.2338 253.88C34.7298 253.64 34.2918 253.286 33.9198 252.818C33.5598 252.338 33.3798 251.702 33.3798 250.91C33.3798 250.166 33.5658 249.518 33.9378 248.966C34.3098 248.414 34.8318 247.994 35.5038 247.706C36.1758 247.406 36.9438 247.256 37.8078 247.256C39.1038 247.256 40.1538 247.574 40.9578 248.21C41.7738 248.834 42.2238 249.71 42.3078 250.838H39.5358C39.5118 250.406 39.3258 250.052 38.9778 249.776C38.6418 249.488 38.1918 249.344 37.6278 249.344C37.1358 249.344 36.7398 249.47 36.4398 249.722C36.1518 249.974 36.0078 250.34 36.0078 250.82C36.0078 251.156 36.1158 251.438 36.3318 251.666C36.5598 251.882 36.8358 252.062 37.1598 252.206C37.4958 252.338 37.9638 252.494 38.5638 252.674C39.3798 252.914 40.0458 253.154 40.5618 253.394C41.0778 253.634 41.5218 253.994 41.8938 254.474C42.2658 254.954 42.4518 255.584 42.4518 256.364C42.4518 257.036 42.2778 257.66 41.9298 258.236C41.5818 258.812 41.0718 259.274 40.3998 259.622C39.7278 259.958 38.9298 260.126 38.0058 260.126ZM47.1565 247.436V260H44.6365V247.436H47.1565ZM52.1663 258.002H56.3063V260H49.6463V247.436H52.1663V258.002ZM69.194 247.436L64.586 260H61.526L56.918 247.436H59.618L63.074 257.426L66.512 247.436H69.194ZM73.2249 249.47V252.62H77.4549V254.618H73.2249V257.948H77.9949V260H70.7049V247.418H77.9949V249.47H73.2249ZM86.765 260L83.993 255.104H82.805V260H80.285V247.436H85.001C85.973 247.436 86.801 247.61 87.485 247.958C88.169 248.294 88.679 248.756 89.015 249.344C89.363 249.92 89.537 250.568 89.537 251.288C89.537 252.116 89.297 252.866 88.817 253.538C88.337 254.198 87.623 254.654 86.675 254.906L89.681 260H86.765ZM82.805 253.214H84.911C85.595 253.214 86.105 253.052 86.441 252.728C86.777 252.392 86.945 251.93 86.945 251.342C86.945 250.766 86.777 250.322 86.441 250.01C86.105 249.686 85.595 249.524 84.911 249.524H82.805V253.214Z"
                fill="black"
            />
            <text x="2.5%" y="67.5%" fill="#333">
                0 - {goldPoints - 1} points
            </text>
        </svg>
    );
};

export default LoyaltyGraphicDesktop;
